export const JARVIS_VOICE={rate:.94,pitch:.84};
export function selectAssistantVoice(voices=[],settings={}){
 const explicit=voices.find(v=>v.name===settings.voice_name);if(explicit)return explicit;
 const language=/^en/i.test(settings.lang||"")?/^en(?:-|$)/i:/^es(?:-|$)/i;
 const spanish=voices.filter(v=>language.test(v.lang||""));
 const male=/jorge|juan|diego|pablo|carlos|antonio|raul|raúl|andres|andrés|gonzalo|miguel|alejandro|alvaro|álvaro|dami[aá]n|rodrigo|tom[aá]s|enrique|daniel|george|arthur|oliver|\bmale\b/i;
 const score=v=>(male.test(v.name)?100:0)+(v.lang===settings.lang?12:0)+(v.localService?3:0)+(/enhanced|premium|natural|mejorada/i.test(v.name)?8:0);
 return [...spanish].sort((a,b)=>score(b)-score(a))[0];
}
export function speechParts(text){
 const clean=String(text||"").replace(/```[\s\S]*?```/g," ").replace(/\[([^\]]+)\]\([^)]+\)/g,"$1").replace(/https?:\/\/\S+/g,"").replace(/[*_#`]/g,"").replace(/\s+/g," ").trim();
 return (clean.match(/[^.!?¿¡]+[.!?]*/g)||[]).flatMap(part=>{
  const chunks=[];let rest=part.trim();while(rest.length>220){let at=rest.lastIndexOf(" ",220);if(at<40)at=220;chunks.push(rest.slice(0,at));rest=rest.slice(at).trim()}if(rest)chunks.push(rest);return chunks;
 });
}
